import { atom } from 'jotai';

export const drawerStatusAtom = atom(false);
